export default __webpack_public_path__ + "static/NoPreviewImage-38daebac765da196054b1d063093a135.png";